import { useState } from 'react';
import { useRequest } from "../hooks/UseRequest";

export const useGetBanners = () => {
  const [isLoadingBanners, setIsLoadingBanners] = useState(false);
  const [banners, setBanners] = useState(null);
  const requests = useRequest();

  const getBanners = async (module_code_key, model_id) => {
    setIsLoadingBanners(true);
    requests.setEndpoint(
      `${process.env.REACT_APP_API_DOMAIN}/${module_code_key}/${model_id}/banner`
    );
    const response = await requests.get();
    setBanners(response.data.data);
    setIsLoadingBanners(false);
  };

  return { getBanners, isLoadingBanners, banners, setBanners };
};
